export const DISPLAY_PLACEHOLDER = "—";

export function normalizeCountryCodeForDisplay(countryCode?: string | null): string {
  if (countryCode === null || countryCode === undefined) return "";
  const s = String(countryCode).replace(/^\+/, "").trim();
  if (!s || s.toLowerCase() === "undefined" || s.toLowerCase() === "null") return "";
  return s;
}
export function formatPhoneForDisplay(countryCode?: string | null, phone?: string | null): string {
  const ph = phone !== null && phone !== undefined ? String(phone).trim() : "";
  if (!ph) return DISPLAY_PLACEHOLDER;
  const cc = normalizeCountryCodeForDisplay(countryCode);
  if (cc) return `(${cc}) ${ph}`;
  return ph;
}
